import { Glue42 } from "../../glue";
import { isObject, isString } from "../activity/helpers/util";

const enum Commands {
    GetCookies = "get-cookies",
    SetCookie = "set-cookie",
    RemoveCookie = "remove-cookie"
}

export class Cookies implements Glue42.Cookies.API {

    constructor(private methodName: string, private interop: Glue42.Interop.API) {
    }

    public async get(filter?: Glue42.Cookies.CookiesGetFilter): Promise<Glue42.Cookies.Cookie[]> {
        const result = await this.invoke<{ cookies: Glue42.Cookies.Cookie[] }>(Commands.GetCookies, { filter });
        return result.returned.cookies;
    }

    public async set(cookie: Glue42.Cookies.CookiesSetDetails): Promise<void> {
        this.verifyCookieObject(cookie);
        await this.invoke<Glue42.Cookies.Cookie[]>(Commands.SetCookie, cookie);
    }

    public async remove(url: string, name: string): Promise<void> {
        if (!isString(url)) {
            throw new Error(`url should be a string`);
        }
        if (!isString(name)) {
            throw new Error(`name should be a string`);
        }
        await this.invoke<Glue42.Cookies.Cookie[]>(Commands.RemoveCookie, { url, name });
    }

    private invoke<T>(command: Commands, data: any) {
        return this.interop.invoke<T>(this.methodName, { command, args: data });
    }

    private verifyCookieObject(cookie: Glue42.Cookies.CookiesSetDetails) {
        if (!cookie) {
            throw new Error(`cookie should be defined`);
        }
        if (!isObject(cookie)) {
            throw new Error(`cookie should be an object`);
        }
    }
}
